import React, {
	useCallback,
	useEffect,
	useLayoutEffect,
	useRef,
	useState,
} from 'react';
import '../../css/Minting.css';
import cardImg from '../../assets/mintingCard.png';
import closeBtn from '../../assets/close_btn.svg';
import alert from '../../assets/minting_alert.svg';
import styled from 'styled-components';
import spaceM from '../../assets/minting_m_header.svg';
import MintingTableMobile from './MintingTableMobile';
import MintingTableWeb from './MintingTableWeb';
import {
	CONTRACT_INFO,
	SEND_ADDRESS_TO_MINTING,
	TOKEN_INFO,
} from '../../contract';
import {
	decryptedData,
	_duman_getTime,
	_fixedPrice,
	_formatPrice,
	_getExchangeData,
	_getKctNftInfo,
	_getMembershipBenefit,
	_getMembershipRank,
	_inputActionLog,
	_postIndex,
	_requestPurchaseBox,
	_whitelist_user_check,
} from '../../function/functions';
import { useRecoilState, useRecoilValue } from 'recoil';
import { membership_rank } from '../../recoil-states/user-state/user-state';
import Loading from '../../component/Loading';
import { ethers } from 'ethers';
import { OAuthData } from '../../recoil-states/user-state/user-OAuth';
import { useAccount, useNetwork, useSigner } from 'wagmi';

const Minting = ({ setOpenMinting, windowWidth, textData, language }) => {
	const DUMAN_PFP_BOX_INDEX = '792ea118-42e3-4dfa-bf0c-c72ba3c72042';
	const amounts = { usdt: 0, kct: 0, eth: 0 };

	const [userMembership, setUserMembership] = useRecoilState(membership_rank);
	const [userData, setUserData] = useRecoilState(OAuthData);
	const [discountRateBymembership, setDiscountRateBymembership] = useState(0);
	const [discountRateByKct, setDiscountRateByKct] = useState(0.1);

	const [product, setProduct] = useState({});
	const [selectedTokenIndex, setSelectedTokenIndex] = useState(0);
	const [quantity, setQuantity] = useState(1);
	const [maxSaleQuantify, setMaxSaleQuantify] = useState(400);
	const [soldQuantify, setSoldQuantify] = useState(400);
	const [exchangeData, setExchangeData] = useState(amounts);
	const [firstAmount, setFirstAmount] = useState(amounts);
	const [totalAmount, setTotalAmount] = useState(amounts);
	const [whiteListData, setWhiteListData] = useState({});
	const [DiscountValue, setDiscountValue] = useState();
	const [loading, setLoading] = useState(false);
	const [dumanTime, setDumanTime] = useState();

	const { isConnected, isDisconnected, address } = useAccount();
	const { data: signer } = useSigner();
	const { chain, chains } = useNetwork();
	const chainId = chain ? chain?.id : chains[0]?.id;

	const supportTokenList = [
		// "KCT",
		'ETH',
	];

	const _inputLogAccount = {
		address: address,
		subAddress: userData?.sub_wallet_address,
	};

	useEffect(() => {
		if (dumanTime === true) {
			setMaxSaleQuantify(400);
		}
	}, []);

	const loacalelang = localStorage.getItem('locale');

	useEffect(() => {
		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = 'unset';
		};
	}, []);
	/**
     * staking 유저 등급, 스테이킹 기간에 따른 이자율을 return 하는 함수입니다.
     * @param {string} account - Address
     * @param {state} userMembership - userMembership state 
     * @promise 
     * _setProductData({ index: DUMAN_PFP_BOX_INDEX }),
      _setExchangeData(),
      _setWhiteListUserCheck(account),
      _setUserMambership(account),
      _switchMembership(userMembership),
      * @function _setData
      * @returns {function} _caculateAmount - 이더가격 계산
    */

	const _setData = (account, userMembership) => {
		Promise.all([
			_setProductData({ index: DUMAN_PFP_BOX_INDEX }),
			_setExchangeData(),
			_setWhiteListUserCheck(account),
			_setUserMambership(account),
			_switchMembership(userMembership),
			_dumangetTime(),
		])
			.then(results => {
				const productDate = results.find(x => x.eth_price);
				const exchangeData = results.find(x => x.eth);
				const ethPrice = productDate.eth_price;
				_calculateAmount(ethPrice, 1, exchangeData);
			})
			.catch(error => {})
			.finally(() => {
				setLoading(false);
			});
	};
	useLayoutEffect(() => {
		setLoading(true);
		_setData(address, userMembership);
		return () => {
			_setData(address, userMembership);
		};
	}, []);

	useLayoutEffect(() => {
		const ethPrice = product.eth_price;
		const amount = _calculateAmount(ethPrice, quantity, exchangeData, 0, 0);
		const discountedAmount = _calculateAmount(
			ethPrice,
			quantity,
			exchangeData,
			discountRateBymembership,
			discountRateByKct
		);

		setFirstAmount(amount);
		setTotalAmount(discountedAmount);
	}, [
		product,
		exchangeData,
		quantity,
		discountRateBymembership,
		discountRateByKct,
		selectedTokenIndex,
	]);
	/**
	 * 유저 등급을 불러와 할인율 설정하여 useState에 저장
	 * @async
	 * @function _setUserMambership
	 * @returns {state} DiscountValue - 할인율
	 */
	async function _setUserMambership(address) {
		try {
			const result = await _getMembershipBenefit(address);
			setDiscountValue(result.data);
		} catch (error) {}
	}
	/**
	 * KCT NFT 정보를 호출하여 useState로 저장
	 * @async
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _setProductData
	 * @returns {state} product - KCT 정보
	 */
	async function _setProductData(filterQueries) {
		try {
			const result = await _getKctNftInfo(filterQueries);
			setProduct(result.data[0]);
			return result.data[0];
		} catch (error) {
			throw new Error(error);
		}
	}
	/**
	 * huobi price를 불러와 저장
	 * @async
	 * @function _setExchangeData
	 * @returns {state} exchangeData - huobi usdt 전일종가
	 */
	async function _setExchangeData() {
		try {
			const result = await _getExchangeData();
			setExchangeData(result.data);
			return result.data;
		} catch (error) {
			throw new Error(error);
		}
	}
	/**
	 * whiteList에 유저가 있는지 체크
	 * @async
	 * @param {string} address
	 * @function _setWhiteListUserCheck
	 * @returns {state} whiteListData - 유저가 whitelist인지 체크
	 * @returns {state} soldQuantify - 전체 박스가 몇개인지 확인
	 */
	async function _setWhiteListUserCheck(address) {
		try {
			const result = await _whitelist_user_check(address);
			setWhiteListData(result.data);
			setSoldQuantify(result.data.total_box);
			if (dumanTime === false) {
				setMaxSaleQuantify(400);
			}
			return result.data;
		} catch (error) {}
	}
	/**
	 * 박스 구매가 가능한 시간인지 체크
	 * @async
	 * @function _dumangetTime
	 * @returns {state} DumanTime - 박스 구매가 가능한 시점확인 timestamp
	 */
	async function _dumangetTime() {
		try {
			const result = await _duman_getTime();
			setDumanTime(result.result);
		} catch (error) {
			throw new Error(error);
		}
	}
	/**
	 * staking 유저 등급, 스테이킹 기간에 따른 이자율을 return 하는 함수입니다.
	 * @param {string} userMembership
	 * @function _switchMembership
	 * @returns {state} discountRateBymembership - 할인율
	 */
	function _switchMembership(userMembership) {
		switch (userMembership) {
			case 'bronze':
				setDiscountRateBymembership(0.03);
				break;
			case 'silver':
				setDiscountRateBymembership(0.05);
				break;
			case 'gold':
				setDiscountRateBymembership(0.07);
				break;
			case 'black':
				setDiscountRateBymembership(0.1);
				break;
			case 'platinum':
				setDiscountRateBymembership(0.3);
				break;
			default:
				break;
		}
	}
	/**
	 * minring에 필요한 값들을 계산
	 * @param {numnrt} ethPrice ETH 가격
	 * @param {number} quantity 수량
	 * @param {object} exchangeData usdt 환율
	 * @param {string} discountRateBymembership 할인율
	 * @param {number} discountRateByKct KCT 기준 할인율
	 * @function _calculateAmount
	 * @returns {object} amounts - 이자율 {usde,eth,kct}
	 */
	function _calculateAmount(
		ethPrice,
		quantity,
		exchangeData,
		discountRateBymembership,
		discountRateByKct
	) {
		let _ethPrice = ethPrice === undefined ? 0 : ethPrice;
		const amount_ethPrice = _ethPrice * quantity;
		const amout_usdt = amount_ethPrice * exchangeData.eth;
		const amounts = {
			usdt:
				selectedTokenIndex === 0
					? _fixedPrice(
							amout_usdt *
								((1 - discountRateBymembership) *
									(1 - discountRateByKct))
					  )
					: _fixedPrice(amout_usdt),
			eth: _fixedPrice(amount_ethPrice),
			kct: _fixedPrice(
				(amout_usdt / exchangeData.kct) *
					((1 - discountRateBymembership) * (1 - discountRateByKct))
			),
		};

		return amounts;
	}
	/**
	 * packge 구매 minting 요청
	 * @async
	 * @function _minting
	 */

	async function _minting() {
		if (!isConnected) {
			window.alert(textData.main['requires login to minting']);
			return;
		}

		if (chainId !== '1') {
			window.alert(`${textData.mypage2.checkNetwork}`);
			return;
		}

		if (maxSaleQuantify - soldQuantify <= 0) {
			window.alert(textData.main['Sold Out']);
			return;
		}

		if (quantity > maxSaleQuantify - soldQuantify) {
			window.alert(textData.main['Purchaseable quantity exceeded']);
			return;
		}

		if (dumanTime === false && quantity > whiteListData.count) {
			window.alert(textData.main['Purchaseable quantity exceeded']);
			return;
		}

		try {
			let transaction;
			let price_toString =
				selectedTokenIndex === 1
					? `${+totalAmount.kct}`
					: `${+totalAmount.eth}`;

			if (selectedTokenIndex === 1) {
				const options = [
					SEND_ADDRESS_TO_MINTING,
					ethers.utils.parseEther(price_toString),
				];

				const contract = new ethers.Contract(
					TOKEN_INFO.address,
					TOKEN_INFO.abi,
					signer
				);

				transaction = await contract.transfer(...options);
			} else if (selectedTokenIndex === 0) {
				const options = {
					to: SEND_ADDRESS_TO_MINTING,
					value: ethers.utils.parseEther(price_toString),
				};
				transaction = await signer.sendTransaction(options);
			}

			if (Object.keys(transaction).length > 0 && quantity === 1) {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'박스 구매 성공',
					JSON.stringify(transaction)
				);
				try {
					let result;
					if (dumanTime === false) {
						const postIndex = await _postIndex(
							whiteListData.index[0],
							address
						);
						if (
							postIndex.RETCODE ===
							'WHITELIST_STATE_UPDATE_SUCCESS'
						) {
							_inputActionLog(
								JSON.stringify(_inputLogAccount),
								'박스를 구매한 유저 화이트 리스트 상태 변경 성공',
								postIndex.RETCODE
							);
							result = await _requestPurchaseBox(
								address,
								DUMAN_PFP_BOX_INDEX,
								transaction.hash,
								price_toString,
								supportTokenList[selectedTokenIndex]
							);
							_inputActionLog(
								JSON.stringify(_inputLogAccount),
								'유저가 구매 요청한 박스 정보 DB에 추가 성공',
								JSON.stringify(result)
							);
							window.alert(textData.main['success minting']);
						} else {
							throw new Error(result);
						}
					} else if (dumanTime === true) {
						result = await _requestPurchaseBox(
							address,
							DUMAN_PFP_BOX_INDEX,
							transaction.hash,
							price_toString,
							supportTokenList[selectedTokenIndex]
						);
						window.alert(textData.main['success minting']);
						_inputActionLog(
							JSON.stringify(_inputLogAccount),
							'유저가 구매 요청한 박스 정보 DB에 추가 성공',
							JSON.stringify(result)
						);
					}
				} catch (error) {
					_inputActionLog(
						JSON.stringify(_inputLogAccount),
						'유저가 구매 요청한 박스 정보 DB에 추가 실패',
						JSON.stringify(error)
					);
					window.alert(textData.main['failed minting']);
				} finally {
					setOpenMinting(false);
				}
			} else if (Object.keys(transaction).length > 0 && quantity === 2) {
				if (dumanTime === false) {
					await Promise.all([
						_postIndex(whiteListData.index[0], address),
						_postIndex(whiteListData.index[1], address),
					])
						.then(result => {
							_inputActionLog(
								JSON.stringify(_inputLogAccount),
								'박스를 구매한 유저 화이트 리스트 상태 변경 성공',
								JSON.stringify(result)
							);
							requestPurchaseBox2(
								transaction.hash,
								price_toString
							);
						})
						.catch(error => {
							_inputActionLog(
								JSON.stringify(_inputLogAccount),
								'박스를 구매한 유저 화이트 리스트 상태 변경 실패',
								JSON.stringify(error)
							);
							window.alert(textData.main['failed minting']);
						})
						.finally(() => {
							setOpenMinting(false);
						});
				} else if (dumanTime === true) {
					try {
						const result = await requestPurchaseBox2(
							transaction.hash,
							price_toString
						);
						setOpenMinting(false);
					} catch (error) {
						window.alert(textData.main['failed minting']);
						throw new Error(error);
					} finally {
						setOpenMinting(false);
					}
				}
			} else if (Object.keys(transaction).length > 0 && quantity === 3) {
				if (dumanTime === true) {
					try {
						const result = await requestPurchaseBox3(
							transaction.hash,
							price_toString
						);
					} catch (error) {
						window.alert(textData.main['failed minting']);
						throw new Error(error);
					} finally {
						setOpenMinting(false);
					}
				} else {
					window.alert(textData.main['failed minting']);
					return false;
				}
			}
		} catch (error) {
			if (error.error.code === -32000) {
				window.alert(textData.main['The amount is insufficient']);
			} else {
				window.alert(textData.main['failed minting']);
			}
		} finally {
			setOpenMinting(false);
		}
	}
	/**
	 * 유저가 구매한 박스 정보를 DB에 추가 (구매한 박스가 2개 일때)
	 * @async
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function requestPurchaseBox2
	 */

	async function requestPurchaseBox2(hash, price) {
		await Promise.all([
			_requestPurchaseBox(
				address,
				DUMAN_PFP_BOX_INDEX,
				hash,
				price / 2,
				supportTokenList[selectedTokenIndex]
			),
			_requestPurchaseBox(
				address,
				DUMAN_PFP_BOX_INDEX,
				hash,
				price / 2,
				supportTokenList[selectedTokenIndex]
			),
		])
			.then(result => {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'유저가 구매 요청한 박스 정보 DB에 추가 성공 2개',
					JSON.stringify(result)
				);
				window.alert(textData.main['success minting']);
			})
			.catch(error => {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'유저가 구매 요청한 박스 정보 DB에 추가 실패 2개',
					JSON.stringify(error)
				);
				window.alert('minting error');
			})
			.finally(() => {
				setOpenMinting(false);
			});
	}
	/**
	 * 유저가 구매한 박스 정보를 DB에 추가 (구매한 박스가 3개 일때)
	 * @async
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function requestPurchaseBox3
	 */
	async function requestPurchaseBox3(hash, price) {
		await Promise.all([
			_requestPurchaseBox(
				address,
				DUMAN_PFP_BOX_INDEX,
				hash,
				price / 3,
				supportTokenList[selectedTokenIndex]
			),
			_requestPurchaseBox(
				address,
				DUMAN_PFP_BOX_INDEX,
				hash,
				price / 3,
				supportTokenList[selectedTokenIndex]
			),
			_requestPurchaseBox(
				address,
				DUMAN_PFP_BOX_INDEX,
				hash,
				price / 3,
				supportTokenList[selectedTokenIndex]
			),
		])
			.then(result => {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'유저가 구매 요청한 박스 정보 DB에 추가 성공 3개',
					JSON.stringify(result)
				);
				window.alert(textData.main['success minting']);
			})
			.catch(error => {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'유저가 구매 요청한 박스 정보 DB에 추가 실패 3개',
					JSON.stringify(error)
				);
				window.alert('minting error');
			})
			.finally(() => {
				setOpenMinting(false);
			});
	}
	/**
	 * minting 모달 닫기
	 * @function offModal
	 */

	const offModal = e => {
		if (e.target.id === 'minting') {
			setOpenMinting(false);
		}
	};
	/**
	 * 구매를 위한 토큰 변경
	 * @function changeToken
	 */
	const changeToken = useCallback(index => {
		setSelectedTokenIndex(index);
	}, []);

	/**
	 * 박스 수량 변경 +
	 * @function plusQuantity
	 */
	const plusQuantity = () => {
		const settingQuantity = dumanTime ? 3 : 2;
		if (quantity > maxSaleQuantify) {
			window.alert('최대 수량 입니다.');
		} else if (quantity >= settingQuantity) {
			if (dumanTime === true) {
				window.alert(textData.main['You can buy up to three']);
			} else {
				window.alert(textData.main['You can buy up to two']);
			}
		} else {
			setQuantity(quantity + 1);
		}
	};
	/**
	 * 박스 수량 변경 -
	 * @function plusQuantity
	 */
	const minusQuantity = () => {
		if (quantity < 1) {
			setQuantity(1);
		}
		setQuantity(quantity - 1);
	};
	return (
		<>
			{loading && <Loading />}
			<div id='minting' onClick={offModal}>
				<div id='minting_container'>
					<div className='close_btn'>
						<img
							src={closeBtn}
							alt='닫기'
							onClick={() => {
								setOpenMinting(false);
							}}
						/>
					</div>
					<div className='space_m_img'>
						<img src={spaceM} />
					</div>
					<div className='minting_mobile_scroll'>
						<div className='minting_left'>
							<div className='left_top'>
								<h1>
									DUMAN PFP{' '}
									{windowWidth > 1024 ? <br /> : null} MINTING
								</h1>
							</div>
							<div className='left_bottom'>
								<img src={cardImg} />
							</div>
						</div>
						<div className='minting_right_box'>
							<div className='minting_time'>
								<p>{textData.minting.time}</p>
								{/* <span>{moment().format('d MMM, hhA')} (KST)</span> */}
								<span>{'31 Aug, 07PM'} (KST)</span>
								{/* 시간 데이터 들어가야되는 구간 */}
							</div>
							<div className='minting_right'>
								<MintingTableMobile
									textData={textData}
									firstAmount={firstAmount}
									totalAmount={totalAmount}
									price={totalAmount}
									membershipLevel={userMembership}
									discountPercent={discountRateBymembership}
								/>
								<MintingTableWeb
									textData={textData}
									firstAmount={firstAmount}
									totalAmount={totalAmount}
									membershipLevel={userMembership}
									discountPercent={discountRateBymembership}
								/>
								<div className='nft_sales'>
									<h2>{textData.minting.nft_sales}</h2>
									<div className='percent_container'>
										{/* 퍼샌트 데이터 */}
										<SalesQuantifyBar
											current={Number(
												maxSaleQuantify - soldQuantify
											)}
											max={maxSaleQuantify}>
											<CurrentSales>
												{Number(
													maxSaleQuantify -
														soldQuantify
												)}
											</CurrentSales>
										</SalesQuantifyBar>
										<div className='percent_text'>
											<p>0</p>
											<p>{maxSaleQuantify}</p>
										</div>
									</div>
								</div>
								<div className='amount'>
									<h2 className='amount_text'>
										{textData.minting.amount}
									</h2>
									<div className='btn_box'>
										<button onClick={minusQuantity}>
											-
										</button>
										<h3>
											{quantity < 1
												? setQuantity(1)
												: quantity}
										</h3>
										{/* 갯수 증가 시키는 로직 */}
										<button onClick={plusQuantity}>
											+
										</button>
									</div>
								</div>
								<div className='pay'>
									<div className='pay_menu'>
										<div className='pay_btn_box'>
											<div className='pay_title'>
												<p className='pay_with'>
													{textData.minting.pay_with}
												</p>
											</div>
											<div className='kct_eth_btn'>
												{supportTokenList.map(
													(token, index) => (
														<button
															onClick={() =>
																changeToken(
																	index
																)
															}
															className={
																selectedTokenIndex ===
																index
																	? 'btn_price_data'
																	: 'btn_disabled'
															}>
															{token}
														</button>
													)
												)}
											</div>
										</div>
										<div className='pay_container'>
											<img src={alert} id='alert_icon' />
											<div className='pay_box'>
												{language === 'en' ? (
													<>
														<p className='pay_alert'>
															If you make a
															payment with KCT ,
															You can save
														</p>
														<span>10%!</span>
													</>
												) : (
													<p className='pay_alert'>
														KCT로 결제시,{' '}
														<span>10%</span>를 할인
														받을 수 있습니다!
													</p>
												)}
											</div>
										</div>
										{/* 버튼을 누를때마다 active 되야하며 KCT , ETH 가 바뀌어야함 */}
									</div>
									<div className='user_pay'>
										<div className='user_pay_result_container'>
											<div className='user_pay_content'>
												<div className='user_pay_title'>
													<h1>
														{
															textData.minting
																.you_pay
														}
													</h1>
												</div>
												<div className='user_pay_right'>
													<div className='user_pay_container'>
														<div className='user_pay_box'>
															<div className='user_pay_result'>
																<p className='user_pay_result_num'>
																	{_formatPrice(
																		totalAmount[
																			supportTokenList[
																				selectedTokenIndex
																			].toLowerCase()
																		]
																	)}
																</p>
																<p className='user_pay_result_name'>
																	{_formatPrice(
																		supportTokenList[
																			selectedTokenIndex
																		]
																	)}
																</p>
																{/* 바뀌어야하는 데이터들 */}
															</div>
														</div>
													</div>

													{selectedTokenIndex ===
													1 ? (
														<div className='user_last_pay'>
															<OriginPriceArrow className='origin_price'>
																<span className='origin_arrow'></span>
																$
																{_formatPrice(
																	firstAmount.usdt
																)}
																{/* 원가 데이터 */}
															</OriginPriceArrow>
															<p className='last_price'>
																$
																{_formatPrice(
																	totalAmount.usdt
																)}{' '}
																{/* 세일 데이터 */}
																<span>
																	10% off
																</span>
															</p>
														</div>
													) : (
														<div className='user_last_pay'>
															<div className='origin_price'>
																$
																{_formatPrice(
																	firstAmount.usdt
																)}
																{/* 원가 데이터 */}
															</div>
														</div>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className='minting_mobile_bottom'>
								<div className='minting_about'>
									<span>*{textData.minting.refreshing}</span>
								</div>
								<div className='minting_submit'>
									<button onClick={_minting}>
										{textData.minting.minting}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

const OriginPriceArrow = styled.p`
	position: relative;
`;

const SalesQuantifyBar = styled.div`
	width: calc(100% / ${props => `${props.max} * ${props.current}`});
	height: 100%;
	background-color: var(--green-300);
	border-radius: 5px;
	position: relative;
`;

const CurrentSales = styled.p`
	font-family: 'NotoSansB';
	color: var(--green-100);
	font-size: 85%;
	margin-bottom: 0;
	position: absolute;
	left: 96%;
	top: 30px;

	&::before {
		content: '';
		width: 0;
		height: 0;
		border-bottom: 5px solid var(--green-300);
		border-top: 5px solid transparent;
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		position: absolute;
		left: 7px;
		bottom: 22px;
	}

	@media screen and (max-width: 1200px) {
		& {
			left: 95%;
			top: 15px;
		}

		&::before {
			left: 8px;
			bottom: 20px;
		}
	}

	@media screen and (max-width: 700px) {
		& {
			left: 93%;
		}
	}

	@media screen and (max-width: 530px) {
		& {
			left: 91%;
		}
	}

	@media screen and (max-width: 430px) {
		& {
			left: 89%;
		}
	}

	@media screen and (max-width: 330px) {
		& {
			left: 86%;
		}
	}

	@media screen and (max-width: 280px) {
		& {
			left: 82%;
		}
	}
`;
export default Minting;
